<template>
  <BaseTabGrid
    :items="items"
    :tab="selectedTab"
    :active-color="getTutorListDesignColor"
  >
    <template #video>
      <div class="tab-content-intro">
        <BasePlayerIframe
          :item="video"
          :title="title"
        />
      </div>
    </template>
    <template #about>
      <div class="tab-content-intro">
        <TeacherListItemAbout
          :show-full="showFull"
          @toggleHeight="toggleHeight"
        />
      </div>
    </template>
  </BaseTabGrid>
</template>

<script>
import BasePlayerIframe from '@design-system/base/player/player-iframe'
import BaseTabGrid from '@design-system/base/tab/tab-grid.vue'
import { mapGetters } from 'vuex'
import TeacherListItemAbout from '~/components/common/teacher-list-items/teacher-list-items-about'
export default {
  name: 'TeacherListItemsIntroduction',
  components: { BasePlayerIframe, TeacherListItemAbout, BaseTabGrid },
  inject: ['teacher'],
  provide () {
    return { isSsr: this.$ssrContext }
  },
  props: {
    showFull: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedTab: 'about'
    }
  },
  computed: {
    ...mapGetters('local', ['getTutorListDesignColor']),
    items () {
      return [
        { name: 'about', title: 'About author', disabled: !this.teacher?.about },
        { name: 'video', title: 'Introduction video', disabled: !this.teacher?.video }
      ]
    },
    video () {
      return this.teacher?.video
    },
    title () {
      return this.teacher?.fullName
    }
  },
  methods: {
    toggleHeight (val) {
      return this.$emit('toggleHeight', val)
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content-intro {
  &__title {
    @apply text__headline-3-xs--bold lg:text__body-2-md--bold text-primary-700 mb-4;
  }
}
</style>
